// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"fdd895dd","121":"fe2fe1b2","154":"0171e6c4","228":"869c638a","348":"62a60981","649":"9724baf0","819":"320fbef7","901":"b1fadc33"}[chunkId] + ".chunk.css";
};